import { PurchaseOrderStatus } from "@redotech/cockroachdb-codegen/tables/inventory/purchase-order-status";
import { purchaseOrderIdFormat } from "@redotech/redo-inventory-id";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const OpenPurchaseOrderSchema_ = z.object({
  id: purchaseOrderIdFormat.schema,
  poNumber: z.string(),
  status: createEnum(PurchaseOrderStatus),
  productIds: z.array(productIdFormat.schema),
});

export const OpenPurchaseOrderSchema: z.ZodType<OpenPurchaseOrder> =
  OpenPurchaseOrderSchema_;
export interface OpenPurchaseOrder extends z.infer<
  typeof OpenPurchaseOrderSchema_
> {}

export const getOpenPurchaseOrdersForProductFamilies = {
  name: "getOpenPurchaseOrdersForProductFamilies" as const,
  input: z.object({
    productFamilyIds: z.array(productFamilyIdFormat.schema).min(1),
  }),
  output: z.object({
    drafts: z.array(OpenPurchaseOrderSchema),
    nonDrafts: z.array(OpenPurchaseOrderSchema),
  }),
};
